import { ProviderModule } from './helpers/account-helper'

const ProviderHubspot = 'hubspot'

const module = ProviderModule(ProviderHubspot)

module.actions.oauthUrl = async (_, { companyId }) => {
	return await useNuxtApp().$fetchCrmBridge(
		`/integrations/oauth-url/?company_id=${companyId}&provider=${ProviderHubspot}`,
	)
}

export default module
